import PortalVue from "portal-vue";
import Fullscreen from "vue-fullscreen";
import VueJsonPretty from "vue-json-pretty";

import { StreemTooltip } from "shared/components/base";
import Checkbox from "shared/components/core/forms/Checkbox.vue";
import Field from "shared/components/core/forms/Field.vue";
import Radio from "shared/components/core/forms/Radio.vue";
import ConfirmDialog from "shared/components/core/modals/ConfirmDialog.vue";
import CoreDialog from "shared/components/core/modals/CoreDialog.vue";
import ConditionalRouterLink from "shared/components/core/various/ConditionalRouterLink.vue";
import TimeAgo from "shared/components/core/various/TimeAgo.vue";

import "vue-json-pretty/lib/styles.css";

export default ({ app }) => {
  app.use(PortalVue);
  app.use(Fullscreen, { name: "Fullscreen" });
  app.component("VueJsonPretty", VueJsonPretty);

  app.component("TimeAgo", TimeAgo);
  app.component("CoreDialog", CoreDialog);
  app.component("ConfirmDialog", ConfirmDialog);
  app.component("Checkbox", Checkbox);
  app.component("Radio", Radio);
  app.component("Field", Field);
  app.component("StreemTooltip", StreemTooltip);
  app.component("ConditionalRouterLink", ConditionalRouterLink);
};
